import Vue from 'vue'
import Vuex from 'vuex'
import createVuexAlong from 'vuex-along'

import { getPlatform } from '@/utils/judge'
import { getLanguage } from '@/lang/index'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    accountId: '',
    groupId: '',
    headImgUrl: '',
    enrtyUrl: '',
    userName: '',
    nickName: '',
    openId: '',
    sex: '',
    unionId: '',
    open: false,
    platform: getPlatform(), // 判断设备
    userGroupId: '', // 群组id
    language: getLanguage()
  },
  getters: {
    language(state) {
      return state.language
    }
  },
  mutations: {
    SET_FLFG: (state, WechatInfo) => {
      state.groupId = WechatInfo.groupId
      state.headImgUrl = WechatInfo.headimgurl
      state.nickName = WechatInfo.nickname
      state.openId = WechatInfo.openid
      state.sex = WechatInfo.sex
      state.unionId = WechatInfo.unionid
    },
    SET_OPEN: (state, open) => {
      state.open = open
    },
    SET_HEADIMGURL: (state, HeadImgUrl) => {
      state.headImgUrl = HeadImgUrl
    },
    SET_USERNAME: (state, Name) => {
      state.userName = Name
    },
    SET_USERGROUPID: (state, userGroupId) => {
      state.userGroupId = userGroupId
    },
    CHANGE_LANGUAGE: (state, language) => {
      state.language = language
    }
  },
  actions: {

  },
  plugins: [createVuexAlong({
    name: 'vuex-along', // 设置保存的集合名字，避免同站点下的多项目数据冲突
    local: {
      list: ['open'],
      isFilter: true // 过滤模块 open 数据
    },
    session: {
      list: ['open', 'userName', 'headImgUrl'] // 保存 open
    },
    justSession: true
  })]
})
